import OurInfomation from './OurInfomation'
export default OurInfomation
